module.exports = __webpack_public_path__ + "img/photo-hit-massage-2020.d596b28e.jpg";